<app-icon-button icon="switch_access_shortcut" *ngIf="showCompanyButton" (click)="switchContext()" class="margin-top-10">
  {{ 'context.' + (contextType === CT.COMPANY ? 'returnToEstate' : 'goToCompany') | locCap }}
</app-icon-button>
